<template>
  <base-layout :menu-items="menuItems" />
</template>

<script>
  import BaseLayout from './BaseLayout.vue'

  export default {
    name: 'App',
    components: {
      BaseLayout
    },
    computed: {
      menuItems () {
        const items = [
          {
            heading: this.$t('Личный кабинет'),
            show: true,
            list: [{
                     id: 'exit',
                     icon: 'exit_to_app',
                     text: this.$t('Выйти'),
                     route: '',
                     method: this.logOut,
                     show: this.isLoggedIn
                   },
                   {
                     id: 'login',
                     icon: 'person',
                     text: this.$t('Войти'),
                     route: `${this.urlRootPath}/login`,
                     show: !this.isLoggedIn
                   },
                   {
                     id: 'authorizationDocuments',
                     icon: 'contacts',
                     text: this.$t('Список документов УП'),
                     route: `${this.urlRootPath}/user/authorizationDocuments`,
                     show: this.isLoggedIn && this.isRegistered
                   },
                   {
                     id: 'changePassword',
                     icon: 'settings_backup_restore',
                     text: this.$t('Изменить пароль'),
                     route: `${this.urlRootPath}/changePassword`,
                     show: this.isLoggedIn
                   }]
          },
          {
            heading: this.$t('Администрирование'),
            show: true,
            list: [
              {
                id: 'published',
                icon: 'gavel',
                text: this.$t('Список опубликованных торговых процедур'),
                route: `${this.urlRootPath}/lots/published`,
                show: true
              },
              {
                id: 'manage',
                icon: 'settings',
                text: this.$t('Управление'),
                route: `${this.urlRootPath}/manage`,
                show: true
              },
              {
                id: 'personal',
                icon: 'gavel',
                text: this.$t('Управление торговыми процедурами'),
                route: `${this.urlRootPath}/lots/personal`,
                show: this.isLoggedIn &&
                  this.isAdmin
              },
              {
                id: 'lotRegistration',
                icon: 'add_box',
                text: this.$t('Создать торговую процедуру'),
                route: `${this.urlRootPath}/lotRegistration`,
                show:
                  this.isLoggedIn &&
                  this.isAdmin
              },
              {
                id: 'incoterms',
                icon: 'mdi-truck',
                text: this.$t('Условия поставки'),
                route: `${this.urlRootPath}/deliveryDictionaries`,
                show:
                  this.isLoggedIn &&
                  this.isAdmin
              }
            ]
          },
          {
            heading: this.$t('Общая информация'),
            show: true,
            list: [{
                     icon: 'work',
                     text: this.$t('Основные документы'),
                     route: `${this.urlRootPath}/generalDocuments`,
                     show: true
                   },
                   {
                     icon: 'chat_bubble',
                     text: this.$t('Служба поддержки'),
                     route: `${this.urlRootPath}/support`,
                     show: true
                   }
            ]
          }
        ]

        return items
      }
    }
  }
</script>
